import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import LoginEmailTokenSentSuccessModal from 'app/domains/routes/Login/LoginEmailTokenSentSuccessModal'
import { PHONE_NOT_FOUND } from 'app/constants/loginErrors'
import LoginInformationModal from 'app/domains/routes/Login/LoginInformationModal'
import CheckEmailSpamIcon from 'app/components/SVGS/CheckEmailSpamIcon'
import SendPhoneForVarification from 'app/components/SVGS/SendPhoneForVarification'
import LoginEmailForm from './LoginEmailForm'
import LoginPhoneForm from './LoginPhoneForm'
import Button from 'app/components/ButtonDefault/ButtonDefault'

import './styles.scss'

const bc = 'login-without-password'

class LoginWithoutPassword extends PureComponent {
  componentDidUpdate() {
    const {
      t,
      loginPhoneError,
      clearAuthStatuses,
      showModal,
      phone,
      isTokenSendToPhone,
      isTokenSendToEmail,
    } = this.props
    if (loginPhoneError === PHONE_NOT_FOUND) {
      showModal(
        <LoginInformationModal
          title={t('We don’t have your number in our system yet!')}
          text={t('Fear not, just click below to send us an email so we can validate the number and get you started!')}
          icon={<SendPhoneForVarification />}
          clearAuthStatuses={clearAuthStatuses}
          button={
            <a href={`mailto:happy@prohabits.com?subject=${phone}`} className={`${bc}__link`}>
              <Button primary stretched>
                {t('Send email')}
              </Button>
            </a>
          }
        />,
        { size: 'mm' }
      )
    }
    if (isTokenSendToPhone) {
      showModal(
        <LoginEmailTokenSentSuccessModal
          title={t('Magic Link sent')}
          body={t('Check your phone for a link to login to ProHabits.')}
          clearAuthStatuses={clearAuthStatuses}
        />,
        { size: 'xs' }
      )
    }
    if (isTokenSendToEmail) {
      showModal(
        <LoginInformationModal
          title={t(`Don’t see your invite email?`)}
          text={t(
            'Check Spam – it might have gone there, right next to that message from your long lost uncle with all that inheritance money'
          )}
          icon={<CheckEmailSpamIcon />}
          clearAuthStatuses={clearAuthStatuses}
        />,
        { size: 'xs' }
      )
    }
  }
  render() {
    const { t, i18n: { language }, countriesCodes } = this.props
    return (
      <div className={bc}>
        <LoginEmailForm title={t('Log in using email')} buttonText={t('Email me a magic link')} isEmailForm />
        <div className={cn(`${bc}__or`, { [`${bc}__or__${language}`]: language })} />
        <LoginPhoneForm
          title={t('Login on your phone')}
          buttonText={t('Text me a magic link')}
          subtitle={t('We will text you a magic link to log into ProHabits on your phone')}
          countriesCodes={countriesCodes}
        />
      </div>
    )
  }
}

export default withTranslation('login')(LoginWithoutPassword)
